import { divIcon, LatLngExpression, LatLngTuple } from 'leaflet'
import React, { ComponentProps, useEffect, useState } from 'react'
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router-dom';
import { MapContainer, Marker, Polyline, Popup, TileLayer, useMap } from 'react-leaflet'
import { useMemo } from 'react';

type Props = {
    postDate?: Date,
    height?: string,
    width?: string,
    cities?: any,
    weather?: boolean
    zoom?: number

}

interface stopExceptionInfo {
    description: string,
    color: string
}
interface ShortStopInfoModified {
    position: [string, string] | any,
    stopHasException: boolean,
    description: string,
    addressName: string,
    stopTopException: stopExceptionInfo,
    routeId: number
}
const LeafletMap = (props: ComponentProps<any>) => {
    const getStopIcon = (stopInfo: stopExceptionInfo) => {
        const color = stopInfo?.color ? stopInfo.color : 'blue'
        return (
            divIcon({
                className: 'custom-div-icon',
                html: `<div style="background-color: ${color}; width: 20px; height: 20px; border-radius: 50% 50% 50% 0; border: 2px solid black; transform: rotate(-45deg)"></div>`,
                iconSize: [12, 12],
                iconAnchor: [6, 6]
            })
        )
    }
    let points: LatLngExpression[] = []
    props?.cities?.map((stops: ShortStopInfoModified) => points.push((stops.position[0] > 90 || stops.position[0] < -90) ? stops.position.reverse() : stops.position))
    const stringCenter: any = points[0] !== null || points[0] !== undefined ? points[0] : [40.7128, -74.00060]
    const center: any = stringCenter !== undefined ? [parseInt(stringCenter[0]), parseInt(stringCenter[1])] : [40.7128, -95.00060]
    const offsetAmount = 500;
    const positionCounts = {};
    const positionIndices = {};
    const location: Location<any> = useLocation()

    const navigate: NavigateFunction = useNavigate();

    const handleNavigate = (routeId: string | number, stopId: any) => {
        const navTo = `/Routed/${routeId}`
        navigate(navTo, {
            state: {
                showRouteModal: true,
                preSetSelectedDateFromMapView: props.postDate,
                openModalFromRouteView: [true, stopId]
            }
        })
    }

    const markers = useMemo(() => {
        return (
            props?.cities?.map((stop: any, idx: number) => stop.position && (
                <Marker
                    key={idx}
                    position={stop.position}
                    icon={getStopIcon(stop?.stopTopException)}
                >
                    <Popup>
                        <div className="text-sm">
                            <p className="font-semibold">{stop.description}</p>
                            <p className="text-gray-600" style={{ cursor: 'pointer' }} onClick={() => handleNavigate(stop.routeId, stop.stopId)}><u>{stop.addressName.replace('<br />', '\n')}</u></p>
                        </div>
                    </Popup>

                </Marker>
            ))
        )
    }, [props?.cities])

    return (
        <div style={{ height: '2rem' }}>
            <MapContainer
                center={center}
                zoom={props.zoom ? props.zoom : 5}
                style={{ height: props?.height ? props.height : "30vh", width: props?.width ? props.width : "auto" }}
            >
                <TileLayer
                    url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    opacity={1}
                />
                {props.weather && <TileLayer
                    url='https://tile.openweathermap.org/map/precipitation/{z}/{x}/{y}.png?appid=7359480d2562df0230a9be49a87e69b1'
                    attribution='&copy; <a href="https://www.openweathermap.org/copyright">OpenWeatherMap</a> contributors'
                    opacity={1}

                />}
                {markers}
            </MapContainer>
        </div >
    )
}

export default LeafletMap